import React, { useState } from "react";
import { Box, Divider, Typography } from '@mui/material';
import FormularioInfoServicio from "../pages/Servicios/FormularioInfoServicio";
import FormularioService from "../pages/Servicios/FormularioService";
import ListaService from "../pages/Servicios/ListaService";
import ListaInfoServicio from "../pages/Servicios/ListaInfoServicio";
import ServicesPages from "../pages/Servicios/ServicesPages";

const DashboardServicioWeb = () => {
    const [serviceSeleccionado, setServiceSeleccionado] = useState(null);
    const [infoServicioSeleccionado, setInfoServicioSeleccionado] = useState(null);
    
    // Función para manejar la edición de los servicios
    const handleEditarServices = (service) => {
        setServiceSeleccionado(service);
        console.log('Estoy en DashboardServicio ' + service);
    };

    // Función para manejar la edición del infoservicio
    const handleEditarInfoServicio = (infoservicio) => {
        setInfoServicioSeleccionado(infoservicio);
        console.log('Estoy en DashboardServicio ' + infoservicio);
    };


    return(
        <Box sx={{
            gap: '20px',
            margin: '10px 5px',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles
                flexDirection: 'column', // Asegurarse que esté en columna
                width: '95%',
                gap: '20px',
                margin: '1% 5%',
            },
        }}>
            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                    },
                }}
            >
                Sección Nuestro servicios
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    borderWidth: '0.1px',
                }} 
            />

            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>
                {/* Agregar Servicio */}
                {<FormularioService serviceSeleccionado={serviceSeleccionado}/>}
                
                {/* lista de servicios */}
                {<ListaService onEditar={handleEditarServices}/>}


            </Box>

            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                    },
                }}
            >
                Sección de la información de Nuestro servicios
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    borderWidth: '0.1px',
                }} 
            />

            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>

                {/*Formulario para agregar el contenido a la página web */}
                <FormularioInfoServicio infoServicioSeleccionado={infoServicioSeleccionado}/>

                {/*Lista de la informació que se muestra en la pagina de handleEditarInfoBlog*/}
                <ListaInfoServicio onEditar={handleEditarInfoServicio} />
            
            </Box>
            <ServicesPages/>
        </Box>
    );
}


export default DashboardServicioWeb;